import { render, staticRenderFns } from "./NavigationLinksBlock.vue?vue&type=template&id=6df3270a&scoped=true&"
import script from "./NavigationLinksBlock.vue?vue&type=script&lang=ts&"
export * from "./NavigationLinksBlock.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationLinksBlock.vue?vue&type=style&index=0&id=6df3270a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df3270a",
  null
  
)

export default component.exports